module.exports = __webpack_public_path__ + "e7b8504385e709e723c059a2c10bac8e.MP3";